import { Component, Input, OnChanges } from '@angular/core';
import { FlowNode } from '@app/utilities/foblex-flow/node-manager';
import { fragQuery } from '@models';
import { Observable, filter, map, shareReplay, startWith } from 'rxjs';
import { FragQueryService } from 'src/injectables/frag-query.service';
import { getSummaryData } from '../../../analysis/analysis.component';
import { DependentNode } from '@app/utilities/foblex-flow/base-node/dependent-node';
import { DeviceNode } from '../device-node/device-node.component';
import { FoblexNode } from '@app/utilities/foblex-flow/base-node/base-node';

export class PSDChartNode extends DependentNode {
    public baseNode: DeviceNode;
    public static type = 'psd-chart';
    public static isPSDChartNode(node: FlowNode): node is PSDChartNode {
        return node.type === this.type;
    }

    constructor(node: DeviceNode) {
        const dimension:FoblexNode.Dimension = { width: 8, height: 4 };
        super(Date.now(), PSDChartNode.type,dimension, node, FoblexNode.Place.Top);
        this.baseNode = node;
    }
}

@Component({
    selector: 'chart-node',
    templateUrl: './chart-node.component.html',
    styleUrls: ['./chart-node.component.scss']
})
export class ChartNodeComponent implements OnChanges {
    @Input() node: PSDChartNode;
 
    public chartData$: Observable<fragQuery.timeline.sieveSizesAtPercents.Interval | null>;
    public hasData$: Observable<boolean | undefined>;

    constructor(
        private readonly fragQuery: FragQueryService,
    ) {}

    public ngOnChanges() {
        if (this.node && PSDChartNode.isPSDChartNode(this.node)) {
            
            const response$ = this.fragQuery
                .getTimelineSieveSizesForDevice(this.node.baseNode.device)
                .pipe(
                    filter(response => {
                        return response !== undefined}),
                    shareReplay(1)
                );

            this.chartData$ = response$.pipe(
                map(response => getSummaryData(response))
            );

            this.hasData$ = response$.pipe(
                map(response => {
                    if (response === null) return false;
                    return response.intervals?.length > 0;
                }),
                startWith(undefined)
            );
        }
    }

}
